import React, { useState } from 'react';
import { css } from '@linaria/core';
import PlusCircleIcon from './../icons/PlusCircle';
import PlusCircleFillIcon from './../icons/PlusCircleFill';
import MinusCircleFillIcon from './../icons/MinusCircleFill';
import MinusCircleIcon from './../icons/MinusCircle';
import classNames from 'classnames';

const group = css`
  padding-top: 10px;
  margin-bottom: 10px;
`;

const groupWithBorder = css`
  border-top: 1px solid #e5dbd1;
`;

const header = css`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 10px 0;
  justify-content: space-between;

  &:focus {
    background: #ffdd00;
  }
`;
const heading = css`
  color: #1a1a1a;
  flex-grow: 1;
  font-size: 22px;
  font-weight: 700;
  line-height: 34px;
  margin: 0;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
  letter-spacing: 0.02em;
  transition: color 300ms ease-in-out;
  user-select: none;

  &:hover {
    color: #1a1a1a;
    text-decoration-thickness: 3px;
    text-underline-offset: 2px;
  }
`;
const headerIcon = css`
  fill: #1a1a1a;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
`;
const fields = css`
  display: none;
`;
const fieldsOpen = css`
  display: block;
  margin-top: 10px;
`;

export default function FormGroup({ children, title, noBorder }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleKeyDown = event => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className={classNames(group, !noBorder && groupWithBorder)}>
      <div
        aria-label={`${isOpen ? 'Collapse' : 'Expand'} ${title}`}
        className={header}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={handleKeyDown}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        role="button"
        tabIndex={0}
      >
        <h3 className={heading}>{title}</h3>

        {isOpen && !isHovered && <MinusCircleFillIcon className={headerIcon} />}
        {isOpen && isHovered && <MinusCircleIcon className={headerIcon} />}
        {!isOpen && !isHovered && <PlusCircleIcon className={headerIcon} />}
        {!isOpen && isHovered && <PlusCircleFillIcon className={headerIcon} />}
      </div>

      <div className={classNames(fields, isOpen && fieldsOpen)}>{children}</div>
    </div>
  );
}
